import { create } from "zustand";

interface ForceExitState {
  shouldForceExit: boolean;
  setShouldForceExit: (value: boolean) => void;
}

export const useForceExitStore = create<ForceExitState>((set) => ({
  shouldForceExit: false,
  setShouldForceExit: (value: boolean) => set({ shouldForceExit: value }),
}));
